export enum ECountry {
  KE = "KE",
  UG = "UG",
  TZ = "TZ",
}
